import { Box, Checkbox, FormControlLabel, Grid, TextField, makeStyles } from '@material-ui/core';
import React from 'react';
import { get, isEmpty } from '../../../../utils/lodash';
import HelpTextIcon from '../../../common/HelpTextIcon';
import { Label } from '../../../common/Label';
import CustomPanel from '../../../common/PanelTemplateWithMandatory';

const useStyles = makeStyles(theme => ({
  subRoot: {
    marginBottom: theme.spacing(4)
  },
  contactDetails: {
    padding: theme.spacing(0, 3, 4, 3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 1, 4, 1)
    }
  },
  inputWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
    }
  },
  addressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '45%',
    height: '100%',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  inputField: {
    minWidth: theme.spacing(30),
    margin: theme.spacing(3, 0, 0, 1),
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(2),
      marginLeft: 0
    },
    '& .Mui-focused': {
      '& label': {
        color: theme.palette.primary.main
      }
    },
    '& .MuiInputLabel-shrink': {
      '& label': {
        fontWeight: 400,
        color: theme.palette.primary.lightBlack
      }
    },
    '& .MuiSelect-select': { whiteSpace: 'normal' }
  },
  checkboxLabel: {
    margin: theme.spacing(4, 0, -1, -0.3)
  },
  inputCheckbox: {
    color: theme.palette.primary.main,
    '&.Mui-checked': {
      color: theme.palette.primary.main
    }
  }
}));

const PermitOfficeSectionOldUI = props => {
  const classes = useStyles();
  const { errorData, handlePermitOffice, permitOffice, sectionLabel, readOnly, stateSelected } = props;
  const {
    permit_office_contact_name = '',
    permit_office_contact_phone = '',
    permit_office_contact_email = '',
    permit_office_contact_address = '',
    permit_office_contact_zip = '',
    online_permit_submission = false,
    permit_tracking_website = ''
  } = permitOffice;

  return (
    <Box className={classes.subRoot}>
      <CustomPanel
        header={sectionLabel}
        icon={
          <HelpTextIcon
            message="When EV Permit Details Needed field checked in basic details section, ensure that all the fields in this section is filled and updated correctly."
            position="right"
            btnClassName={classes.button}
          />
        }
      >
        <Grid className={classes.contactDetails}>
          <Grid className={classes.inputWrapper}>
            <Box className={classes.addressWrapper}>
              <TextField
                className={classes.inputField}
                label={<Label text={'Contact Name'} />}
                value={permit_office_contact_name}
                onChange={e => handlePermitOffice(e, 'permit_office_contact_name')}
                error={!isEmpty(get(errorData, 'permit_office_contact_name'))}
                helperText={get(errorData, 'permit_office_contact_name')}
                disabled={readOnly || !stateSelected}
              />
            </Box>
            <Box className={classes.addressWrapper}>
              <TextField
                className={classes.inputField}
                id={'permit_office_contact_phone'}
                label={<Label text={'Contact Phone Number'} />}
                placeholder={'e.g. +1 xxx xxx xxxx'}
                value={permit_office_contact_phone}
                onChange={e => handlePermitOffice(e, 'permit_office_contact_phone')}
                error={!isEmpty(get(errorData, 'permit_office_contact_phone'))}
                helperText={get(errorData, 'permit_office_contact_phone')}
                disabled={readOnly || !stateSelected}
              />
            </Box>
          </Grid>
          <Grid className={classes.inputWrapper}>
            <Box className={classes.addressWrapper}>
              <TextField
                className={classes.inputField}
                label={<Label text={'Contact Email Address'} />}
                id={'permit_office_contact_email'}
                value={permit_office_contact_email}
                onChange={e => handlePermitOffice(e, 'permit_office_contact_email')}
                error={!isEmpty(get(errorData, 'permit_office_contact_email'))}
                helperText={get(errorData, 'permit_office_contact_email')}
                disabled={readOnly || !stateSelected}
              />
            </Box>
            <Box className={classes.addressWrapper}>
              <TextField
                className={classes.inputField}
                label={<Label text={'Office Address Line'} />}
                value={permit_office_contact_address}
                onChange={e => handlePermitOffice(e, 'permit_office_contact_address')}
                error={!isEmpty(get(errorData, 'permit_office_contact_address'))}
                helperText={get(errorData, 'permit_office_contact_address')}
                disabled={readOnly || !stateSelected}
              />
            </Box>
          </Grid>
          <Grid className={classes.inputWrapper}>
            <Box className={classes.addressWrapper}>
              <TextField
                className={classes.inputField}
                label={<Label text={'Office Zip'} />}
                id={'permit_office_contact_zip'}
                value={permit_office_contact_zip}
                placeholder={'e.g. xxxxx or xxxxx-xxxx'}
                onChange={e => handlePermitOffice(e, 'permit_office_contact_zip')}
                error={!isEmpty(get(errorData, 'permit_office_contact_zip'))}
                helperText={get(errorData, 'permit_office_contact_zip')}
                disabled={readOnly || !stateSelected}
              />
            </Box>
            <Box className={classes.addressWrapper}>
              <TextField
                className={classes.inputField}
                label={<Label text={'Permit Tracking Website'} />}
                value={permit_tracking_website}
                onChange={e => handlePermitOffice(e, 'permit_tracking_website')}
                error={!isEmpty(get(errorData, 'permit_tracking_website'))}
                helperText={get(errorData, 'permit_tracking_website')}
                disabled={readOnly || !stateSelected}
              />
            </Box>
          </Grid>
          <Grid className={classes.inputWrapper}>
            <Box className={classes.checkboxWrapper}>
              <FormControlLabel
                className={classes.checkboxLabel}
                disabled={!stateSelected || readOnly}
                checked={online_permit_submission}
                control={<Checkbox className={classes.inputCheckbox} />}
                label="Online Permit Submissions"
                value={online_permit_submission}
                onChange={e => handlePermitOffice(e, 'online_permit_submission')}
              />
            </Box>
          </Grid>
        </Grid>
      </CustomPanel>
    </Box>
  );
};

export default PermitOfficeSectionOldUI;
